'use strict';

export const FETCH_ATTEMPTS = 'attempts/FETCH_ATTEMPTS';
export const FETCH_ATTEMPTS_COMPLETED = 'attempts/FETCH_ATTEMPTS_COMPLETED';
export const FETCH_USER_ATTEMPTS = 'attempts/FETCH_USER_ATTEMPTS';
export const FETCH_USER_ATTEMPTS_COMPLETED = 'attempts/FETCH_USER_ATTEMPTS_COMPLETED';
export const FETCH_USER_DAILY_ATTEMPTS = 'attempts/FETCH_USER_DAILY_ATTEMPTS';
export const FETCH_USER_DAILY_ATTEMPTS_COMPLETED = 'attempts/FETCH_USER_DAILY_ATTEMPTS_COMPLETED';
export const FETCH_USER_WEEKLY_ATTEMPTS = 'attempts/FETCH_USER_WEEKLY_ATTEMPTS';
export const FETCH_USER_WEEKLY_ATTEMPTS_COMPLETED = 'attempts/FETCH_USER_WEEKLY_ATTEMPTS_COMPLETED';
export const POST_ATTEMPT = 'attempts/POST_ATTEMPT';
export const POST_ATTEMPT_COMPLETED = 'attempts/POST_ATTEMPT_COMPLETED';
export const POST_EDIT_ATTEMPT = 'attempts/POST_EDIT_ATTEMPT';
export const POST_EDIT_ATTEMPT_COMPLETED = 'attempts/POST_EDIT_ATTEMPT_COMPLETED';
export const POST_DELETE_ATTEMPT = 'attempts/POST_DELETE_ATTEMPT';
export const POST_DELETE_ATTEMPT_COMPLETED = 'attempts/POST_DELETE_ATTEMPT_COMPLETED';
